import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    description: 'Aggregate Inventory Modal header',
    defaultMessage: 'Total Available',
    id: 'aV9ghb',
  },
  description: {
    description: 'Aggregate Inventory Modal description of how total available is calculated',
    defaultMessage:
      'This list shows the quantity available from all inventory sources. The total available displayed includes only the inventory from sources enabled in your <link>Inventory Sync</link> settings.',
    id: 'V6EVph',
  },
  source: {
    description: 'Inventory table column header for indicating the name for the source of an inventory count',
    defaultMessage: 'Inventory Source',
    id: 'HXWxGI',
  },
  warehouseLocation: {
    description: 'Aggregate Inventory Modal Warehouse column',
    defaultMessage: 'Warehouse',
    id: 'g+7TQ5',
  },
  status: {
    description: 'Aggregate Inventory Modal Status column',
    defaultMessage: 'Status',
    id: 'KD38nO',
  },
  included: {
    description: 'Inventory table column header for indicating if an inventory count is included in the total',
    defaultMessage: 'Included',
    id: 'XTyJvp',
  },
  lastUpdated: {
    description: 'Aggregate Inventory Modal Last Updated column',
    defaultMessage: 'Last Updated',
    id: '4SA7Km',
  },
  quantity: {
    description: 'Aggregate Inventory Modal Quantity column',
    defaultMessage: 'Qty',
    id: 'gcEoKD',
  },
  inactiveSync: {
    description: 'Aggregate Inventory Modal Inactive sync message',
    defaultMessage:
      'Inventory from this source has failed to sync in the past hour. Check the connection to the source to ensure your data will properly sync.',
    id: 'P32j/d',
  },
  shipstationInventory: {
    description: 'Aggregate Inventory Modal row ShipStation Inventory',
    defaultMessage: 'ShipStation Internal Inventory',
    id: 'a3OIvv',
  },
});
